import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import FilterSelect from '../../../components/select/filterSelect';
import { MenuItem } from '@mui/material';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import ModalCustom from '../../../components/modal/ModalCustom';
import InputDatePicker from '../../../components/input/inputDatePicker';
import { degreeApi } from '../../../api/degree/degree.api';
import { facultyApi } from '../../../api/factulty/factulty.api';
import moment from 'moment';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import { routeName } from '../../../routes/routeName';
import { YearsApi } from '../../../api/yeas/years.api';
import { useTranslation } from 'react-i18next';
import { AcademicYearApi } from '../../../api/academic-year/academic-year.api';
const defaultSearch = {
    id_faculty: 'ALL',
    year: "",
    term: "ทุกภาคเรียน", // i18n-ignore: semester filter sentinel value
    id_degree: 'ALL'
}
const defaultState = {
    id_faculty: 0,
    academic_year: "",
    course_of_study_start_date: undefined,
    course_of_study_end_date: undefined,
    semester: "",
    id_degree: 0
}

export default function CourseOfStudy() {
    // const currentYear = new Date().getFullYear() + 543; // ค.ศ. -> พ.ศ.
    // const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const { t, i18n } = useTranslation();

    const [search, setSearch] = useState<any>(defaultSearch)
    const [form, setForm] = useState<any>(defaultState)
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const [type, setType] = useState<string>("CREATE");

    const [dataDegree, setDataDegree] = useState<any[]>([]);
    const [dataFaculty, setDataFaculty] = useState<any[]>([]);
    const [dataDegreeAcademicYear, setDataDegreeAcademicYear] = useState<any[]>([]);
    const [dataFacultyAcademicYear, setDataFacultyAcademicYear] = useState<any[]>([]);
    const [dataYears, setDataYears] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [open, setOpen] = useState<boolean>(false);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search.year !== 'ทุกปีการศึกษา') condition = { ...condition, academic_year: search.year }; // i18n-ignore: sentinel comparison
            if (search.term !== 'ทุกภาคเรียน') condition = { ...condition, semester: search.term }; // i18n-ignore: sentinel comparison
            if (search.id_degree !== 'ALL') condition = { ...condition, id_degree: search.id_degree }
            if (search.id_faculty !== 'ALL') condition = { ...condition, id_faculty: search.id_faculty }
            const res = await CourseOfStudyApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data?.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search.id_faculty, search.id_degree, search.year, search.term]);

    const fetchGetDegreeAcademicYear = async (id: number) => {
        const res = await CourseOfStudyApi.academicDetailLunch(id)
        const data = res.data;
        if (data.status < 300) {
            const uniqueDegree = res.data.data.reduce((acc: any[], curr: any) => {
                if (!acc.some(item => item.id_degree === curr.id_degree)) {
                    acc.push({
                        id_degree: curr.id_degree, // ถ้า null ให้เป็น 5
                        degree_name: curr.degree_name,
                        degree_name_eng: curr.degree_name_eng,
                    });
                }
                return acc;
            }, []);

            setDataDegreeAcademicYear(uniqueDegree);
        } else {
            setDataDegreeAcademicYear([]);
        }
    };
    const fetchGetFacultyAcademicYear = async (id: number, id_degree: any) => {
        const res = await CourseOfStudyApi.academicDetailLunch(id)
        const data = res.data;
        if (data.status < 300) {
            const uniqueFaculty = res.data.data.filter((x: any) => x?.id_degree === id_degree).reduce((acc: any[], curr: any) => {
                if (!acc.some(item => item.id_faculty === curr.id_faculty)) {
                    acc.push({
                        id_faculty: curr.id_faculty, // ถ้า null ให้เป็น 5
                        faculty_name: curr.faculty_name,
                        faculty_name_eng: curr.faculty_name_eng,
                    });
                }
                return acc;
            }, []);

            console.log(uniqueFaculty);
            setDataFacultyAcademicYear(uniqueFaculty);
        } else {
            setDataFacultyAcademicYear([]);
        }
    };
    const fetchGetDegree = async () => {
        const res = await degreeApi.getDegree();
        const data = res.data;
        if (data.status < 300) {
            setDataDegree(data.data);
        } else {
            setDataDegree([]);
        }
    };

    const fetchGetFaculty = async () => {
        const res = await facultyApi.getFaculty();
        const data = res.data;
        if (data.status < 300) {
            setDataFaculty(data.data);
        } else {
            setDataFaculty([]);
        }
    };
    // const fetchGetYears = async () => {
    //     const res = await YearsApi.getYears();
    //     const data = res.data;
    //     if (data.status < 300) {
    //         setDataYears(data.data);
    //     } else {
    //         setDataYears([]);
    //     }
    // };

    const getAcademicYearList = async () => {
        let query: any = {
            page: 1,
            limit: 1000,
        }
        await AcademicYearApi.getAcademicYearListActive(query).then((res) => {
            if (res.status < 300) {
                setDataYears(res.data?.data.items.map((x: any) => { return { ...x, year: x?.academic_year } }) || []);
                setSearch({ ...search, year: res.data?.data.items[0]?.academic_year })
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getAcademicYear = async (id: number, term: any) => {

        await AcademicYearApi.getAcademicYearById(id).then((res) => {
            console.log(term);
            if (res.status < 300) {
                setForm({ ...form, semester: term, course_of_study_start_date: term === '1' ? res.data.data.semester_1_start : term === '2' ? res.data.data.semester_2_start : res.data.data.semester_3_start, course_of_study_end_date: term === '1' ? res.data.data.semester_1_end : term === '2' ? res.data.data.semester_2_end : res.data.data.semester_3_end })
                fetchGetDegreeAcademicYear(id)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        fetchGetDegree()
        fetchGetFaculty()
        // fetchGetYears()
        getAcademicYearList()
    }, [])
    useEffect(() => {
        loadData();
    }, [loadData]);

    const headCells = [
        {
            id: "#",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.ACADEMIC_YEAR"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.SEMESTER"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.LEVEL"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '200px',
            sortable: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.FACULTY"),
        },
        // {
        //     id: "status",
        //     disablePadding: false,
        //     width: '300px',
        //     sortable: false,
        //     align: "center",
        //     label: "สาขา",
        // },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("COUNRSE_OF_STUDT.LAST_UPDATED_BY"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("COUNRSE_OF_STUDT.LAST_UPDATED_DATE"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '230px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            academic_year,
            faculty_name,
            degree_name,
            semester,
            id_course_of_study,
            modified_name,
            create_name,
            created_date,
            modified_date
        } = objData;

        const objRenderData = {
            key: id_course_of_study,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: academic_year || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: semester,
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        degree_name || ''
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name,
                },

                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: (
                //         ''
                //     ),
                // },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modified_name || create_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : dateTimeToView(created_date),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableCopy
                            enableResolution
                            enableEdit
                            enableDelete
                            onViewClick={() => {
                                getDetail(id_course_of_study)
                                // setForm(objData)
                                setType("VIEW")
                            }}
                            onCopy={() => {
                                getDetail(id_course_of_study)
                                // setForm(objData)
                                setType("COPY")
                            }}
                            onResolutionClick={() => {
                                navigate(
                                    routeName.cms.CourseOfStudyDetail.replace(':id', id_course_of_study)
                                );
                            }}
                            onEditClick={() => {

                                getDetail(id_course_of_study)
                                setType("EDIT")

                            }}
                            onDeleteClick={() => {
                                alertActive(t('ยืนยันที่จะลบ หรือไม่?'), '', t('ยืนยัน'), t('ยกเลิก'), () => {
                                    handleDelete(id_course_of_study)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const getDetail = async (id: any) => {
        const res = await CourseOfStudyApi.findById(id);
        const data = res.data;
        if (data.status < 300) {
            fetchGetDegreeAcademicYear(data.data.id_academic_year)
            fetchGetFacultyAcademicYear(data.data.id_academic_year, data.data.id_degree)
            // setDataDegreeAcademicYear([data.data.degree])
            // setDataFacultyAcademicYear([data.data.faculty])
            setForm(data.data);
            setOpen(true)

        } else {
            setForm(defaultState);
        }
    }
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }
    const handleCreate = async () => {
        const body = {
            id_faculty: form?.id_faculty,
            academic_year: form?.academic_year,
            id_academic_year: form?.id_academic_year,
            course_of_study_start_date: form?.course_of_study_start_date,
            course_of_study_end_date: form?.course_of_study_end_date,
            semester: form?.semester,
            id_degree: form?.id_degree
        };
        if (type === 'EDIT') {
            await CourseOfStudyApi.patch(body, form.id_course_of_study).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('COUNRSE_OF_STUDT.EDIT_SCHEDULE_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        } else {
            await CourseOfStudyApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(type === "COPY" ? t('COUNRSE_OF_STUDT.COPY_SCHEDULE_SUCCESS') : t('COUNRSE_OF_STUDT.ADD_SCHEDULE_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        }
    }

    const handleDelete = async (id: any) => {
        await CourseOfStudyApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('COUNRSE_OF_STUDT.DELETE_SCHEDULE_SUCCESS'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }


    return (
        <div>
            <ContentHeading
                title={t("COUNRSE_OF_STUDT.MANAGE_SCHEDULE")}
                detail={t("COUNRSE_OF_STUDT.PLEASE_SELECT_OPTION")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={search.year || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={dataYears.map((item: any, index: number) => (
                            <MenuItem value={item?.year} key={index + 1}>
                                {item?.year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("year", e.target.value)
                            setSearch({ ...search, year: e.target.value })
                        }}
                    />

                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={search.term || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={['ทุกภาคเรียน', '1', '2', '3'].map((year: any, index: number) => ( // i18n-ignore: semester filter sentinel value, rendered with t
                            <MenuItem value={year} key={index + 1}>
                                {index === 0 ? t(year) : year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearch({ ...search, term: e.target.value })
                        }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={search.id_degree || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[{ id_degree: 'ALL', degree_name: t('ทุกระดับ') }, ...dataDegree]?.map((item: any, index: number) => (
                            <MenuItem value={item?.id_degree} key={index + 1}>
                                {i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearch({ ...search, id_degree: e.target.value })
                        }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={search.id_faculty || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[{ id_faculty: 'ALL', faculty_name: t('ทุกหลักสูตร') }, ...dataFaculty]?.map((item: any, index: number) => (
                            <MenuItem value={item?.id_faculty} key={index + 1}>
                                {i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearch({ ...search, id_faculty: e.target.value })
                        }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>
                {/* <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article> */}

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            setOpen(true)
                            setType("CREATE")
                        }}
                        mode="add"
                        buttonName={t("COUNRSE_OF_STUDT.ADD_SCHEDULE")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={type === 'CREATE' ? t("COUNRSE_OF_STUDT.ADD_SCHEDULE") : t('COUNRSE_OF_STUDT.SCHEDULE_INFO')} subTitle={t('COUNRSE_OF_STUDT.SUBTITLE')} open={open} component={
                <div className='flex flex-col gap-4'>
                    <div>
                        <FilterSelect
                            heading={t('COUNRSE_OF_STUDT.ACADEMIC_YEAR')}
                            value={form.academic_year || ""}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={dataYears.map((item: any, index: number) => (
                                <MenuItem value={item?.year} key={index + 1}>
                                    {item?.year}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_academic_year: dataYears?.find((x) => x?.academic_year === e.target.value)?.id_academic_year, academic_year: e.target.value, course_of_study_start_date: '', course_of_study_end_date: "" })
                            }}
                            disabled={type === 'VIEW'}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            heading={t('COUNRSE_OF_STUDT.SEMESTER')}
                            value={form?.semester || ""}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={['1', '2', '3'].map((year: any, index: number) => (
                                <MenuItem value={year} key={index + 1}>
                                    {year}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // setForm({ ...form, term: e.target.value,})
                                getAcademicYear(form?.id_academic_year, e.target.value)
                            }}
                            disabled={type === 'VIEW'}
                        />
                    </div>
                    <div>
                        <InputDatePicker
                            heading={t('COUNRSE_OF_STUDT.SEMESTER_START_DATE')}
                            helperText={""}
                            allowClear
                            // disableFuture
                            disabled
                            onChange={(e: any) => {
                                // handleChangeValueSearch("date", moment(e).format("YYYY-MM-DD"));
                                setForm({ ...form, course_of_study_start_date: moment(e).format("YYYY-MM-DD") })
                            }} value={form?.course_of_study_start_date || ''} />
                    </div>
                    <div>
                        <InputDatePicker
                            heading={t('COUNRSE_OF_STUDT.SEMESTER_END_DATE')}
                            helperText={""}
                            allowClear
                            // disableFuture
                            disabled
                            onChange={(e: any) => {
                                // handleChangeValueSearch("date", moment(e).format("YYYY-MM-DD"));
                                setForm({ ...form, course_of_study_end_date: moment(e).format("YYYY-MM-DD") })
                            }} value={form?.course_of_study_end_date || ''} />
                    </div>
                    <div>
                        <FilterSelect
                            heading={t('COUNRSE_OF_STUDT.LEVEL')}
                            value={form.id_degree || ""}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={dataDegreeAcademicYear?.map((item: any, index: number) => (
                                <MenuItem value={item?.id_degree} key={index + 1}>
                                    {i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("year", e.target.value)
                                setForm({ ...form, id_degree: e.target.value })
                                fetchGetFacultyAcademicYear(form?.id_academic_year, e.target.value)
                            }}
                            disabled={type === 'VIEW'}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            heading={t('COUNRSE_OF_STUDT.FACULTY')}
                            value={form.id_faculty || ""}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={dataFacultyAcademicYear?.map((item: any, index: number) => (
                                <MenuItem value={item?.id_faculty} key={index + 1}>
                                    {i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("year", e.target.value)
                                setForm({ ...form, id_faculty: e.target.value })
                            }}
                            disabled={type === 'VIEW'}
                        />
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t('ยกเลิก')}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => handleCreate()}
                            disabled={!form?.academic_year || !form?.semester || !form.id_degree || !form?.id_faculty}
                            mode='add'
                            buttonName={type === 'COPY' ? t('คัดลอก') : t('ยืนยัน')}
                        />}
                    </div>
                </div>
            } />
            {/* <FullCalendar
                plugins={[timeGridPlugin]}
                initialView="timeGridWeek"
                events={[
                    {
                        title: "กิจกรรมทุกวันจันทร์",
                        daysOfWeek: [1],
                        startTime: "10:00:00",
                        endTime: "12:00:00",
                    },
                ]}
                allDaySlot={false}
                locale={thLocale}
                firstDay={0}
                headerToolbar={false}
                slotMinTime="08:00:00"
                slotMaxTime="19:30:00"
                slotLabelFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                }}
                dayHeaderFormat={{
                    weekday: 'long'
                }}
                height="auto"
                direction='rtl'
            /> */}
        </div>

    )
}
